import React from 'react';
import { getBezierPath, EdgeLabelRenderer } from 'reactflow';

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
}) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const relationTypes = [
    "理由", "具体例", "結論", "補足", "反論", "提案"
  ];

  const handleRelationChange = (evt) => {
    const newRelation = evt.target.value;
    if (data && data.onUpdateEdge) {
      data.onUpdateEdge(id, newRelation);
    }
  };

  return (
    <>
      <path
        id={id}
        style={style}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />
    </>
  );
}
